import * as React from 'react';
import type { SVGProps } from 'react';
const IconCircleTickFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconCircleTickFilled"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.984-14.379-4.948 4.952-2.117-2.123-1.416 1.413 3.531 3.54L17.4 9.036z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconCircleTickFilled;
